import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';

import { getBulkOperationById } from '../apis/bulkOperationApi';

import { useInvalidateBulkOperation } from './useInvalidateImport';

export const useBulkOperationQuery = (bulkOperationId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const { invalidateBulkOperation } =
    useInvalidateBulkOperation(bulkOperationId);

  const {
    data: bulkOperation,
    isLoading: loading,
    error: queryError,
  } = useQuery({
    queryKey: ['bulk-operation', bulkOperationId],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      return getBulkOperationById(bulkOperationId, token);
    },
    enabled: !!bulkOperationId,
    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes
  });

  const error = queryError?.message || null;

  return {
    bulkOperation,
    loading,
    error,
    refetch: invalidateBulkOperation,
  };
};
